export default __webpack_public_path__ + "static/media/dancing_pig.2020989e.mp4";